export interface DepartmentTreeNode {
  id: number;
  label: string;
  fullLabel?: string;
  headCount?: number;
  isVirtual?: boolean;
  isApproval?: boolean;
  headNames?: string;
  children?: DepartmentTreeNode[];
}

export enum DepartmentRoleType {
  CC = "CC",
  OWNER = "OWNER",
}

export interface DepartmentRequest {
  id?: number | null;
  name?: string;
  isVirtual?: boolean;
  isApproval?: boolean;
  children?: DepartmentRequest[];
}
